import { BroadcastStatus, Channel, Program } from '../../../interfaces';
import { useRecording } from '../../../queries/ats/recordings/hooks';
import { broadcastStatus } from '../../../utils/huaweiUtils';
import FutureProgram from './FutureProgram';
import LiveProgram from './LiveProgram';
import PastProgram from './PastProgram';
import './TvGuidePlaybillProgram.scss';

export interface RouteProps {
  channelId: string;
  catchupId: string;
}

interface Props {
  channel: Channel;
  program: Program;
  filterActive: boolean;
}

export default function ChannelPlaybill({ channel, program, filterActive }: Props) {
  const { data: recording } = useRecording(program.id, program.lifetimeId);

  function renderMarkers() {
    return <>{recording !== undefined && <li className="pvr-icon">7</li>}</>;
  }

  const currentBroadcastStatus = broadcastStatus({ starttime: program.starttime, endtime: program.endtime });

  switch (currentBroadcastStatus) {
    case BroadcastStatus.Finished:
      return <PastProgram channel={channel} program={program} markers={renderMarkers()} />;
    case BroadcastStatus.Live:
      return (
        <LiveProgram
          channel={channel}
          program={program}
          markers={renderMarkers()}
          isRecording={recording !== undefined}
          filterActive={filterActive}
        />
      );
    case BroadcastStatus.Future:
      return <FutureProgram channel={channel} program={program} markers={renderMarkers()} />;
  }
}
